import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import botanicheska302Data from '../../data/projects/botanicheska302.js';

function Botanicheska302() {
  return <ProjectPage projectData={botanicheska302Data} />;
}

export default Botanicheska302;
